import { Component, OnInit, ViewChild, ChangeDetectorRef, AfterViewInit, OnChanges } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { AttendancesService } from '../attendance/services/attendances.service';
import { Attendance } from '../attendance/models/attendance';
import { AuthenticationService } from 'src/app/auth/services/authentication.service';
import { HolidaysService } from '../holidays/services/holidays.service';
import { PAGE_SIZE_OPTIONS, PAGE_LENGTH, ITEMS_PER_PAGE, CURRENT_PAGE, DASHBOARD_ITEMS_PER_PAGE, DASHBOARD_PAGE_SIZE_OPTIONS } from 'src/app/shared/constants/pagination.constants';
import { LeavesService } from '../leaves/services/leaves.service';

import {AgmMap, MapsAPILoader  } from '@agm/core';
import { MatDialogConfig, MatDialog } from '@angular/material/dialog';
import { AttendanceCreateComponent } from '../attendance/components/attendance-create/attendance-create.component';
import * as moment from 'moment-timezone';
import { Role } from 'src/app/auth/models/user';
import { LoaderService } from 'src/app/auth/services/loader.service';
import Swal from 'sweetalert2';
import { BarChartComponent } from 'src/app/shared/components/charts/bar-chart/bar-chart.component';
import { environment } from 'src/environments/environment';


const dialogConfig= new MatDialogConfig();
dialogConfig.disableClose = true;
dialogConfig.autoFocus = true;

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.css']
})
export class DashboardComponent implements OnInit,AfterViewInit {
  environment = environment;
  @ViewChild(BarChartComponent, { static: false }) barChart: BarChartComponent;

  Role = Role;

  public hasRole:string = this.authenticationService.hasRole();

  displayedColumns: string[] = ['org_name', 'applied_user', 'leave_from','leave_to','leave_days','applied_to'];
  holidaysDisplayedColumns: string[] = ['org_name', 'holiday_on', 'holiday_for'];
  weekStatusDisplayedColumns: string[] = ['name','date', 'signin', 'signout','hours'];

  holidaysDataSource:any;
  leavesDataSource:any;
  weekStatusDataSource:any;

  @ViewChild('holidaysPaginator', {static: true}) holidaysPaginator: MatPaginator;
  @ViewChild('leavesPaginator', {static: true}) leavesPaginator: MatPaginator;
  @ViewChild('weekStatusPaginator', {static: true}) weekStatusPaginator: MatPaginator;

   
  public PAGE_SIZE_OPTIONS_DATA:number[] = DASHBOARD_PAGE_SIZE_OPTIONS;
 
  public holidays_page_length:number = PAGE_LENGTH;

  public holidays_items_per_page:number = DASHBOARD_ITEMS_PER_PAGE;

  public holidays_current_page:number = CURRENT_PAGE;


  public weekStatus_page_length:number = PAGE_LENGTH;

  public weekStatus_items_per_page:number = DASHBOARD_ITEMS_PER_PAGE;

  public weekStatus_current_page:number = CURRENT_PAGE;


  public leaves_page_length:number = PAGE_LENGTH;

  public leaves_items_per_page:number = DASHBOARD_ITEMS_PER_PAGE;

  public leaves_current_page:number = CURRENT_PAGE;

  public leave_loader:boolean = false;
  public holidays_loader:boolean = false;
  public weekStatus_loader:boolean = false;
  

  public attendance:Attendance;
  public date:Date =new Date();

  public user_details = this.authenticationService.getUserDetails();
  public shiftStartAt:string = (this.user_details.shift != null)?this.user_details.shift.start_at :'';
  public shiftEndAt:string = (this.user_details.shift != null)?this.user_details.shift.end_at :'';
  public userTimezone:string = (this.user_details.timezone != null)? this.user_details.timezone : "Asia/Kolkata";
  public username:string = (this.user_details.name != null)? this.user_details.name : "";

  public eventTypeTxt:string;
  public eventType:string = this.authenticationService.getEventType();
  public isNewTaskShow:boolean;

  public working_on:string = this.authenticationService.getWorkingOn();

  public currentLat;
  public currentLong;
  public isTracking;
  public getAddress;
  public zoom;
  public currentLocation:string = '';

  
  public fromMaxDate:Date;
  public fromMinDate:Date;
  public toMaxDate:Date;
  public toMinDate:Date;

  public chartDataSource:any;
  public isDataLoad:boolean = false;

  public AdvancedSearchForm:FormGroup;

  public isDisabled:boolean = false;

  @ViewChild(AgmMap,{static: true}) public agmMap: AgmMap;

  constructor(
    private cd: ChangeDetectorRef,
    private dialog:MatDialog,
    
    private authenticationService:AuthenticationService,
    private attendanceService:AttendancesService,
    private apiloader: MapsAPILoader,
    private holidaysService:HolidaysService,
    private leaveService:LeavesService,
    private loaderService:LoaderService,
    private fb:FormBuilder,
    ){
    
  }

  ngOnInit() {
   
    this.createAdvancedSearchForm();
    this.AdvancedSearchFormSubmit();

    this.getLastEventType();
    this.getHolidays();
    this.getLeaves();
    this.setEventType();
    this.getThisWeekClockInAndClockOutTimes();
    this.cd.detectChanges();
    this.eventType = this.authenticationService.getEventType();
    this.eventTypeTxt = (this.eventType == '1' )? 'Clock In' : 'Clock Out';
    this.agmMap.triggerResize(true);
  
  }

  ngAfterViewInit(){
    if(this.holidaysDataSource != undefined){
      this.holidaysDataSource.paginator = this.holidaysPaginator;
    }
    if(this.weekStatusDataSource != undefined){
      this.weekStatusDataSource.paginator = this.weekStatusPaginator;
    }
    if(this.leavesDataSource != undefined){
      this.leavesDataSource.paginator = this.leavesPaginator;
    }  
  }


  getCurrentLocation(){
    this.eventTypeTxt = `<div class="la-ball-fall"><div></div><div></div><div></div></div>`;
    this.isDisabled = true;
    if (navigator.geolocation) {
        const $this = this;
        navigator.geolocation.getCurrentPosition(
          (position: any) => {
            if (position) { 
              this.currentLat = position.coords.latitude; //16.517454;//
              this.currentLong =  position.coords.longitude; //81.725342;//
              this.getAddress=(this.currentLat,this.currentLong)
        
              this.apiloader.load().then(() => {
                let geocoder = new google.maps.Geocoder;
                let latlng = {lat: this.currentLat, lng: this.currentLong};
              
                geocoder.geocode({'location': latlng}, function(results) {
                    if (results[0]) {
                      $this.currentLocation= results[0].formatted_address;
                      // console.log($this.currentLocation);
                      $this.createAttendance();
                    } else {
                      // $this.createAttendance();
                      console.log('Not found');
                    }
                });
              });
        
            }else{
              // $this.createAttendance();
              console.log(`position not found.`)
            }
          },
          (err)=>{
            console.log(`Geolocation Error :: `,err);
            $this.currentLocation = "";
            $this.createAttendance();
          })
    }else{
      this.createAttendance();
      console.log(`Geolocation not supported.`);
    }
  
  }

  setEventType(){
    if((this.eventType == null)){
      this.authenticationService.setEventType('1');
      this.isNewTaskShow = false;
    }else{
      this.eventType = this.authenticationService.getEventType();
      this.isNewTaskShow = (this.eventType === '1')? false : true;
    }
  }

  workingOn():void{
    
    dialogConfig.width ="40%";
    const dialogRef = this.dialog.open(AttendanceCreateComponent,dialogConfig);

    // UPDATE CONTACT DETAILS AFTER CREATING THE CONTACT
    dialogRef.afterClosed().subscribe(
        data => {
        // console.log("Dialog output:", data);
        this.authenticationService.setWorkingOn(data.working_on);
        this.working_on = data.working_on;
        this.dialog.closeAll();
        this.getCurrentLocation();
    });  
  }

  createAttendance(){

    this.eventTypeTxt = `<div class="la-ball-fall"><div></div><div></div><div></div></div>`;
    this.cd.detectChanges();

    this.eventType = this.authenticationService.getEventType();

    //we will you later
    // this.toCheckEventTypes();    

    this.attendance = {
      event_type: this.eventType,
      // event_date_time: moment().format('YYYY-MM-DD HH:mm:ss'),// new Date(),
      working_on: this.working_on,
      event_location: this.currentLocation,
      type: '2',
    }

    this.attendanceService.createAttendance(this.attendance).subscribe(
      (res:any)=>{
        // console.log(res);
          if(res && Object.keys(res).length > 0){
            this.toCheckEventTypes();   
          }
      },(err)=>{
        console.log(err);
        Swal.fire({
          icon: 'error',
          title: 'Oops...',
          text: 'Something went wrong! Please try again later.',
        });
      },
      ()=>{
        this.isDisabled = false;
      }
    );

  }

  getLastEventType():void{
    this.attendanceService.getLastEventType().subscribe(
      (res:any) =>{
        if(res.lastEventType != 'null') {
          this.eventType = res.lastEventType;
          this.toCheckEventTypes();
        }
      }
    )
  }

  getHolidays():void{
    this.holidays_loader = true;
    this.loaderService.isTableLoding.next(true);

    let filterParams = this.addHolidaysFilterParameters();

    this.holidaysService.getHolidays(filterParams).subscribe(
        (res:any)=>{
          // console.log("Responsive Data :: ",res);
          this.loaderService.isTableLoding.next(false);
          this.holidays_loader = false;

          this.holidays_page_length = res.headers.get('X-Pagination-Total-Count');
          this.holidays_current_page = res.headers.get('X-Pagination-current-page');
          this.holidays_items_per_page = res.headers.get('X-Pagination-Per-Page');
          this.holidaysDataSource = new MatTableDataSource<any>(res.body);
          // this.holidaysDataSource.paginator = this.holidaysPaginator;
      }
    );
  }

  getLeaves():void{
    this.leave_loader = true;
    this.loaderService.isTableLoding.next(true);

    let filterParams = this.addLeavesFilterParameters();
    this.leaveService.getLeaves(filterParams).subscribe(
      (res)=>{
        // console.log(`Responsive Data :: `,res);
        this.loaderService.isTableLoding.next(false);
        this.leave_loader = false;

        this.leaves_page_length = res.headers.get('X-Pagination-Total-Count');
        this.leaves_current_page = res.headers.get('X-Pagination-current-page');
        this.leaves_items_per_page = res.headers.get('X-Pagination-Per-Page');
        this.leavesDataSource = new MatTableDataSource<any>(res.body);
      }
    );
  }

  getWorkingTimeByDateRange(filterParams = {}){
    
    this.attendanceService.getWorkingTimeByDateRange(filterParams).subscribe(
      (res:any)=>{
        this.isDataLoad = true; 
        // console.log(res);
        this.chartDataSource = res;
        this.cd.detectChanges();
        if(this.hasRole == '2'){
          this.barChart.updateChartData();
        }
      }
    )
  }

  getThisWeekClockInAndClockOutTimes(){
    this.weekStatus_loader = true;
    this.loaderService.isTableLoding.next(true);

    let filterParams = this.addWeekStatusFilterParameters();

    this.attendanceService.getThisWeekClockInAndClockOutTimes(filterParams).subscribe(
        (res:any)=>{
          // console.log("Responsive Data :: ",res);   
          this.loaderService.isTableLoding.next(false);
          this.weekStatus_loader = false;
          this.weekStatus_page_length = res.headers.get('X-Pagination-Total-Count');
          this.weekStatus_current_page = res.headers.get('X-Pagination-current-page');
          this.weekStatus_items_per_page = res.headers.get('X-Pagination-Per-Page');
          this.weekStatusDataSource = new MatTableDataSource<any>(res.body);
      }
    );
  }

  addWeekStatusFilterParameters():Object{
    let filterParams = {};
    filterParams['page']=this.weekStatus_current_page;
    filterParams["per-page"]=this.weekStatus_items_per_page;
    filterParams["sort"] = "-id";
    return filterParams;
  }

  addHolidaysFilterParameters():Object{
    let filterParams = {};
    filterParams['page']=this.holidays_current_page;
    filterParams["per-page"]=this.holidays_items_per_page;
    filterParams["sort"] = "-id";
    return filterParams;
  }

  addLeavesFilterParameters():Object{
    let filterParams = {};
    filterParams['page']=this.leaves_current_page;
    filterParams["per-page"]=this.leaves_items_per_page;
    filterParams["sort"] = "-id";
    return filterParams;
  }

  holidaysHandlePage(e?: any):void {
    if(e){
      this.holidays_current_page = e.pageIndex + 1;
      this.holidays_items_per_page = e.pageSize;
      this.holidays_page_length = e.length;
    }
    this.getHolidays();
  }

  weekStatusHandlePage(e?: any):void {
    if(e){
      this.weekStatus_current_page = e.pageIndex + 1;
      this.weekStatus_items_per_page = e.pageSize;
      this.weekStatus_page_length = e.length;
    }
    this.getThisWeekClockInAndClockOutTimes();
  }

  leavesHandlePage(e?: any):void {
    if(e){
      this.leaves_current_page = e.pageIndex+1;
      this.leaves_items_per_page = e.pageSize;
      this.leaves_page_length = e.length;
    }
    this.getLeaves();
  }

  toggleTask():void{
    this.eventTypeTxt = "Confirm";
    this.isNewTaskShow = true;
  }

  toCheckEventTypes():void{
    if( this.eventType == '2'){
      this.authenticationService.setEventType('1');
      this.eventTypeTxt = 'Clock In';
      this.working_on = '';
      this.isNewTaskShow = false; 
      this.authenticationService.removeWorkingOn();
      this.getThisWeekClockInAndClockOutTimes();
    }else if(this.eventType == '1'){
      this.authenticationService.setEventType('2');
      this.eventTypeTxt = 'Clock Out';
      this.isNewTaskShow = true;
    } 
  }

  setMinAndMaxValues():void{
    this.fromMinDate = new Date();
    this.toMinDate = new  Date();
  }

   /*** TO SET TO_DATE MINIMUN VALUE, WHICH IS NOTHING BUT CURRENT VALUE OF FROM_DATE ***/
   onFromDateChange(event):void{
    this.toMinDate = event.target.value;
  }

  /*** TO SET FROM_DATE MAXIMUM VALUE, WHICH IS NOTHING BUT CURRENT VALUE OF TO_DATE ***/
  onToDateChange(event):void{
    this.fromMaxDate = event.target.value;
  }



  createAdvancedSearchForm():void{
    this.AdvancedSearchForm = this.fb.group({
      from_date: [moment().tz(this.userTimezone).format("YYYY-MM-DD")],
      to_date: [moment().tz(this.userTimezone).format("YYYY-MM-DD")],
    });
  }

  AdvancedSearchFormSubmit(){
  if(this.AdvancedSearchForm.value.from_date != "")
  this.AdvancedSearchForm.patchValue({
    from_date: moment(this.AdvancedSearchForm.value.from_date).tz(this.userTimezone).format("YYYY-MM-DD"),
  });

  if(this.AdvancedSearchForm.value.to_date != "")
    this.AdvancedSearchForm.patchValue({
      to_date: moment(this.AdvancedSearchForm.value.to_date).tz(this.userTimezone).format("YYYY-MM-DD"),
    });

   let filterParams = this.AdvancedSearchForm.value;
   this.getWorkingTimeByDateRange(filterParams)
  }
  formatUserId(userId: string | number): string {
    const userIdString = userId.toString(); // Ensure it's a string
    return userIdString.padStart(5, '0'); // Add '0' prefix if length is less than 3
  }


}
